import { createSlice } from '@reduxjs/toolkit';


export interface LibraryState {
  id: string
}

const initialState: LibraryState = {
  id: '',
};

export const library = createSlice({
  name: 'basic',
  initialState,
  reducers: {
    changeId(state, action) {
      return {
        ...state,
        id: action.payload?.id,
      };
    },
    init(state) {
      return {
        ...state,
        id: '',
      };
    },
  },
});

export const { init, changeId } = library.actions;

export default library.reducer;
